import React from 'react';
import { Tooltip } from 'react-tippy';

/**
 * Render a tooltip-enabled TextInput if the `tooltip` prop is passed in,
 * otherwise, render a normal text input.
 * Note: you can view the tooltip options here: // https://github.com/tvkhoa/react-tippy
 * @param {*} props 
 */
const TextInput = (props) => {
    const { tabIndex, className, id, tooltip, value, readOnly, onChange, placeholder } = props;

    function renderInput() {
        // The easist way to "turn off" the tooltips for demoing purposes 
        // would be to make sure that this condition below returns false
        // i.e: `if (false === true)`
        if (tooltip && tooltip !== '') {
            return (
                <Tooltip
                    title={tooltip}
                    position="top"
                    trigger="mouseenter"
                    delay={200}
                >
                    <input
                        tabIndex={tabIndex || 0}
                        className={className}
                        id={id}
                        value={value}
                        readOnly={readOnly}
                        onChange={onChange}
                        placeholder={placeholder || ''} />
                </Tooltip>
            );
        }
        return (
            <input
                tabIndex={tabIndex || 0}
                className={className}
                id={id}
                value={value}
                readOnly={readOnly}
                onChange={onChange}
                placeholder={placeholder || ''}
            />
        );
    }

    return (
        renderInput()
    );
};

export default TextInput;
